import React from 'react';
import { Container } from '@/components/ui/Container';
import { ContentCard, ActionsWrap } from '@/pages/inside/tenant/style';

const CARD_BASE_STYLE = {
    border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
    background: 'var(--ant-color-bg-elevated, #ffffff)',
    boxShadow: '0 10px 28px rgba(15, 23, 42, 0.06)',
    marginBottom: 0,
};

/**
 * Shared bug card shell used across project task-detail modals.
 * Keeps card visuals and header/footer spacing consistent.
 */
export default function ProjectBugCard({
    headerLeft,
    headerRight,
    children,
    footer,
    cardStyle,
    cardPadding = '12px 14px',
}) {
    return (
        <ContentCard $padding={cardPadding} style={{ ...CARD_BASE_STYLE, ...(cardStyle || {}) }}>
            <ActionsWrap
                style={{
                    marginBottom: 8,
                    justifyContent: 'space-between',
                    width: '100%',
                    alignItems: 'flex-start',
                }}
            >
                <Container $display="flex" $flexDirection="column" $gap="4px" style={{ flex: 1, minWidth: 0 }}>
                    {headerLeft}
                </Container>
                {headerRight ? (
                    <Container $display="flex" $alignItems="center" $gap="8px" style={{ flexShrink: 0 }}>
                        {headerRight}
                    </Container>
                ) : null}
            </ActionsWrap>

            {children}

            {footer ? (
                <ActionsWrap
                    style={{
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: 8,
                        marginTop: 10,
                    }}
                >
                    {footer}
                </ActionsWrap>
            ) : null}
        </ContentCard>
    );
}
